// Hilfsfunktion: holt das aktuelle Firebase-ID-Token und gibt einen Authorization-Header zurück.
// Wird an alle eigenen /api/*-Calls geheftet, damit der Serverless-Endpoint die User-Identität verifizieren kann.
// getIdTokenSafe ist plattformübergreifend: Web = JS-SDK, Native = Auth-Plugin
// (auf Native ist auth.currentUser leer, das Token hält die native Session).
import { getIdTokenSafe } from '../lib/tokenProvider';

export async function authHeader() {
  try {
    const token = await getIdTokenSafe();
    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
  } catch {
    return {};
  }
}
